
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTvClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#tvClock_0ac1bdba3da23163__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 71.994,
  r: 20.533,
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M94.267 66.311a.833.833 0 0 1 1.442.836l-4.901 8.46a.833.833 0 0 1-1.442-.836l4.9-8.46Z",
  fill: "var(--theme-primary, #9631ff)",
  stroke: "var(--theme-primary, #9631ff)",
  strokeWidth: 1.933
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.598 73.112a.834.834 0 1 1 .83-1.446l4.974 2.858a.834.834 0 1 1-.831 1.446l-4.973-2.858Z",
  fill: "var(--theme-primary, #9631ff)",
  stroke: "var(--theme-primary, #9631ff)",
  strokeWidth: 1.933
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M89.015 59.31a.99.99 0 0 1 1.98.01l-.01 2.019a.99.99 0 0 1-1.98-.01l.01-2.02ZM89.015 83.31a.99.99 0 0 1 1.98.01l-.01 2.019a.99.99 0 0 1-1.98-.01l.01-2.02ZM103.014 71.339a.991.991 0 0 1-.009 1.98l-2.019-.01a.991.991 0 0 1 .009-1.98l2.019.01ZM79.014 71.339a.99.99 0 0 1-.01 1.98l-2.018-.01a.99.99 0 0 1 .01-1.98l2.018.01Z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 0.675
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.225 88.06H22a6 6 0 0 1-6-6V37.837a6 6 0 0 1 6-6h75.851a6 6 0 0 1 6 6v10.598",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.739 98.603H44.112",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "tvClock_0ac1bdba3da23163__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h120v120H0z"
})))));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g clip-path=\"url(#clip0_21275_2533)\">\r\n<circle cx=\"90.0001\" cy=\"71.9943\" r=\"20.5333\" stroke=\"black\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M94.2666 66.3113C94.4969 65.9138 95.0054 65.7776 95.4035 66.0068C95.8031 66.2368 95.9399 66.7477 95.7088 67.1467L90.808 75.6069C90.5777 76.0044 90.0692 76.1405 89.6711 75.9114C89.2715 75.6813 89.1347 75.1705 89.3658 74.7714L94.2666 66.3113Z\" fill=\"var(--theme-primary, #9631ff)\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"1.93297\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M84.5979 73.1124C84.1974 72.8823 84.0602 72.3706 84.2918 71.971C84.5221 71.5735 85.0306 71.4372 85.4289 71.6661L90.4018 74.5236C90.8022 74.7537 90.9395 75.2654 90.7079 75.665C90.4776 76.0625 89.9691 76.1988 89.5707 75.9699L84.5979 73.1124Z\" fill=\"var(--theme-primary, #9631ff)\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"1.93297\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M89.0148 59.3099C89.0175 58.7651 89.4598 58.3248 90.0046 58.3246C90.5535 58.3244 90.9978 58.7707 90.9951 59.3196L90.9852 61.3386C90.9825 61.8834 90.5402 62.3237 89.9954 62.3239C89.4465 62.3241 89.0022 61.8777 89.0049 61.3288L89.0148 59.3099Z\" fill=\"black\" stroke=\"black\" stroke-width=\"0.675393\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M89.0148 83.3099C89.0175 82.7651 89.4598 82.3248 90.0046 82.3246C90.5535 82.3244 90.9978 82.7707 90.9951 83.3196L90.9852 85.3386C90.9825 85.8834 90.5402 86.3237 89.9954 86.3239C89.4465 86.3241 89.0022 85.8777 89.0049 85.3288L89.0148 83.3099Z\" fill=\"black\" stroke=\"black\" stroke-width=\"0.675393\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M103.014 71.339C103.559 71.3417 103.999 71.784 104 72.3288C104 72.8777 103.553 73.322 103.005 73.3193L100.986 73.3094C100.441 73.3067 100.001 72.8644 100 72.3196C100 71.7707 100.447 71.3264 100.995 71.3291L103.014 71.339Z\" fill=\"black\" stroke=\"black\" stroke-width=\"0.675393\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M79.0143 71.339C79.5591 71.3417 79.9994 71.784 79.9996 72.3288C79.9998 72.8777 79.5535 73.322 79.0046 73.3193L76.9857 73.3094C76.4409 73.3067 76.0006 72.8644 76.0004 72.3196C76.0002 71.7707 76.4465 71.3264 76.9954 71.3291L79.0143 71.339Z\" fill=\"black\" stroke=\"black\" stroke-width=\"0.675393\"/>\r\n<path d=\"M66.2249 88.0608H22C18.6863 88.0608 16 85.3745 16 82.0608V37.8359C16 34.5222 18.6863 31.8359 22 31.8359H97.8514C101.165 31.8359 103.851 34.5222 103.851 37.8359V48.4343\" stroke=\"black\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n<path d=\"M75.7388 98.6035H44.1123\" stroke=\"black\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</g>\r\n<defs>\r\n<clipPath id=\"clip0_21275_2533\">\r\n<rect width=\"120\" height=\"120\" fill=\"white\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/tvClock.0ac1bdba3da23163badf6f5a1425297c.svg"),
        {
          React: SvgTvClock,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      